/* global FastClick, Modernizr */

$(function() {
    'use strict';

    var user = {
        id: null,
        read: {},
        itinerary: 0,
        itineraryFinished: false,
        pills: 0,
    };

    function randomId() {
        var id = '';
        for (var i = 0; i < 32; i += 1) {
            id += Math.floor(Math.random() * 16).toString(16);
        }
        return id;
    }

    function loadUser() {
        user = JSON.parse(localStorage.getItem('anxioscript')) || {};
        if (!user.id) {
            user.id = randomId();
        }
        if (!user.read) {
            user.read = [];
        }
        if (typeof user.itinerary !== 'number') {
            user.itinerary = 0;
            user.itineraryFinished = false;
            user.pills = 0;
        }
    }

    function saveUser() {
        localStorage.setItem('anxioscript', JSON.stringify(user));
    }

    function checkRead() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var endTop = $('#end').offset().top;
        var endHeight = $('#end').height();

        if (scrollTop + windowHeight >= endTop + endHeight) {
            if (user.itinerary !== 'easteregg' && !user.read[user.itinerary]) {
                user.read[user.itinerary] = true;
                saveUser();
            }
            if (!user.itineraryFinished) {
                if (user.itinerary === 'easteregg') {
                    trackEvent('easteregg');
                } else {
                    trackEvent('itinerary-' + user.itinerary);
                }
                user.itineraryFinished = true;
                saveUser();
            }
        }
    }

    function setItinerary(newItinerary) {
        var visible = {
            '#text-1':   [0, 1, 2, 3, 4, 5, 6, 7],
            '#pill-1':   [0, 1, 2, 3, 4, 5, 6, 7],
            '#turn-1':   [   1,    3,       6, 7],
            '#noturn-1': [0,    2,    4, 5      ],
            '#text-2':   [0, 1, 2, 3, 4, 5, 6, 7],
            '#pill-2':   [0, 1, 2, 3, 4, 5, 6, 7],
            '#turn-2':   [            4, 5, 6, 7],
            '#noturn-2': [0, 1, 2, 3            ],
            '#pill-3':   [0, 1, 2, 3, 4, 5, 6, 7],
            '#turn-2-1': [               5,    7],
            '#turn-2-2': [            4,    6   ],
            '#turn-3':   [      2, 3            ],
            '#noturn-3': [0, 1,                 ],
            '#end':      [0, 1, 2, 3, 4, 5, 6, 7],
            '#name-0': [0],
            '#name-1': [1],
            '#name-2': [2],
            '#name-3': [3],
            '#name-4': [4],
            '#name-5': [5],
            '#name-6': [6],
            '#name-7': [7],
            '#easteregg': ['easteregg'],
        };
        var enabled = {
            '#pill-1': [0],
            '#pill-2': [0, 1],
            '#pill-3': [0, 1, 4, 6],
        };
        var administered = {
            '#pill-1': [1,    3,       6, 7],
            '#pill-2': [         4, 5, 6, 7],
            '#pill-3': [   2, 3,    5,    7],
        };
        $.each(visible, function(id, itineraries) {
            if ($.inArray(newItinerary, itineraries) >= 0) {
                $(id).removeAttr('hidden');
            } else {
                $(id).attr('hidden', '');
            }
        });
        $.each(enabled, function(id, itineraries) {
            if ($.inArray(newItinerary, itineraries) >= 0) {
                $(id).removeClass('pill-disabled');
            } else {
                $(id).addClass('pill-disabled');
            }
        });
        $.each(administered, function(id, itineraries) {
            if ($.inArray(newItinerary, itineraries) >= 0) {
                $(id).addClass('pill-administered');
            } else {
                $(id).removeClass('pill-administered');
            }
        });
        user.itinerary = newItinerary;
    }

    function trackEvent(action) {
        if (window.goatcounter) {
            window.goatcounter.count({
                path: 'anxioscript:' + action,
                referrer: window.location.host + window.location.pathname,
                event: true
            });
        }
    }

    if (Modernizr.localstorage) {
        loadUser();
        setItinerary(user.itinerary);

        if ($('#end').length) {
            setInterval(checkRead, 1000);
        }

        $.each(user.read, function (index, read) {
            if (read) {
                $('#read-' + index).removeAttr('hidden');
            }
        });
    }

    if ($('main.read').length) {
        $('#help-toggle').removeAttr('hidden');
    }

    $('#nav-toggle').on('click', function() {
        $('#help').removeClass('expanded');
        $('nav').toggleClass('expanded');
    });

    $('#nav-close').on('click', function() {
        $('nav').removeClass('expanded');
    });

    $('#help-toggle').on('click', function() {
        if (!$('#help').hasClass('expanded')) {
            $('#help')
                .css('top', $('header').outerHeight())
                .css('left', $('.read').offset().left);
            trackEvent('help');
        }
        $('nav').removeClass('expanded');
        $('#help').toggleClass('expanded');
    });

    $('#help-close').on('click', function() {
        $('#help').removeClass('expanded');
    });

    $(window).on('resize', function() {
        $('nav, #help').removeClass('expanded');
    });

    $('#pill-1, #pill-2, #pill-3').on('click', function() {
        var transitions = {
            'pill-1': {0: 1},
            'pill-2': {0: 4, 1: 6},
            'pill-3': {0: 2, 1: 3, 4: 5, 6: 7},
        };
        user.pills += 1;
        if (user.pills >= 10) {
            setItinerary('easteregg');
            $(window).scrollTop(0);
        } else if (!$(this).hasClass('pill-disabled')) {
            setItinerary(transitions[this.id][user.itinerary]);
        }
        saveUser();
    });

    $('#readagain').on('click', function() {
        $('nav, #help').removeClass('expanded');
        $(window).scrollTop(0);
        setItinerary(0);
        user.itineraryFinished = false;
        user.pills = 0;
        saveUser();
        trackEvent('readagain');
    });

    $('#reset').on('click', function() {
        $('.itinerary-read').attr('hidden', '');
        user.read = {};
        user.itinerary = 0;
        user.itineraryFinished = false;
        user.pills = 0;
        saveUser();
        trackEvent('reset');
    });

    FastClick.attach(document.body);
});
